(() => {
  // Publish counts only; never read or forward contact input values.
  const publish = name => {
    try {
      if (!window.Shopify?.analytics?.publish) return false;
      window.Shopify.analytics.publish(name, {});
      return true;
    } catch { return false; }
  };
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const link = event.target.closest('a');
    if (link?.matches('[data-product-inquiry]')) publish('vetra:product_inquiry');
    if (link?.matches('.support-email[href^="mailto:"]')) publish('vetra:contact_email_click');
  });
  const key = 'vetra-contact-success-counted';
  let counted = false;
  const readCounted = () => { try { return sessionStorage.getItem(key) === '1'; } catch { return counted; } };
  document.addEventListener('submit', event => {
    if (!event.target.matches('.contact-form')) return;
    try { sessionStorage.removeItem(key); } catch { /* Form remains usable without storage. */ }
    counted = false;
  });
  const success = () => {
    if (!document.querySelector('[data-contact-success]') || readCounted()) return;
    let attempts = 0;
    const count = () => {
      if (readCounted()) return;
      if (publish('vetra:contact_success')) {
        counted = true;
        try { sessionStorage.setItem(key, '1'); } catch { /* In-memory fallback. */ }
      } else if (++attempts < 20) setTimeout(count, 250);
    };
    count();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', success, { once: true });
  else success();
})();
